/**
 * All possible status codes for an item.
 */
export const STATUS_CODES = ['05', '10', '20', '30', '40', '70', '80', '90'] as const;

/**
 * All possible status codes for the overall status of an item.
 */
export const OVERALL_STATUS_CODES = ['05', '10', '20', '30', '40', '90'] as const;
